export default {
  ToggleSideBar: ({commit}) => {
      commit('TOGGLE_SIDEBAR')
    },
}



// WEBPACK FOOTER //
// ./src/core/store/actions.js